export const TRADE_TYPES = {
  EXPORT: 'Export',
  IMPORT: 'Import'
}

export const LANGUAGES = {
  ENGLISH: 'English',
  TURKISH: 'Turkish'
}

export const EMAIL_ACCOUNT_TYPES = {
  GMAIL_OAUTH2: 'GMAIL_OAUTH2',
  USERNAME_PASSWORD: 'USERNAME_PASSWORD',
  EXTERNAL_SERVICE: 'EXTERNAL_SERVICE'
}

export const tradeTypeOptions = [
  { value: TRADE_TYPES.EXPORT, label: TRADE_TYPES.EXPORT },
  { value: TRADE_TYPES.IMPORT, label: TRADE_TYPES.IMPORT }
]

export const languageOptions = [
  { value: LANGUAGES.ENGLISH, label: LANGUAGES.ENGLISH },
  { value: LANGUAGES.TURKISH, label: LANGUAGES.TURKISH }
]
